export default {"src":"/_next/static/media/ledger.cb6e0150.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};